
	// vue
	import { defineComponent, computed, onMounted, toRef } from "vue";
	// components
	import vueButton from "@/components/vueButton.vue";
	// type definition
	import SourceType from "@/typeScript/definition/notify/SourceType";

	export default defineComponent({
		name: "VueForm",

		components: {
			vueButton
		}, // components

		props: {
			title: {
				required: false,
				type: String,
				default: null
			},

			description: {
				required: false,
				type: String,
				default: null
			},

			// sets the manual alerts
			alertID: {
				required: false,
				type: Object as () => SourceType,
				default: { parent: null, child: null }
			},

			//sets the manual alerts
			alertMessage: {
				required: false,
				type: Object,
				default: null
			},
			ctx: {
				required: true,
				type: Function
			},
			tag: {
				required: false,
				type: String,
				default: null
			},
			text: {
				required: false,
				type: String,
				default: "Submit"
			},
			category: {
				required: false,
				type: String,
				default: "standard",
				validator: (value: string): boolean =>
					[
						"standard",
						"large",
						"small",
						"fullWidth",
						"border",
						"border-sm",
						"border-lg",
						"border-fwidth",
						"text",
						"text-sm",
						"text-lg",
						"icon",
						"icon-sm",
						"icon-lg",
						null
					].indexOf(value) !== -1
			},
			icon: {
				required: false,
				type: String,
				default: "fas fa-clipboard-check"
			},
			singleAction: {
				required: false,
				type: Boolean,
				default: false
			},
			isAutocomplete: {
				required: false,
				type: Boolean,
				default: true
			},
			validate: {
				required: false,
				type: Boolean,
				default: false
			}
		}, // props

		setup(props) {
			const TAG = toRef(props, "tag");
			const ALERT = toRef(props, "alertMessage");
			const VALIDATE = toRef(props, "validate");

			let formElement = document.getElementById(TAG.value);

			onMounted(() => {
				formElement = document.getElementById(TAG.value);
			});

			// returns true if inputs entered are valid
			// or validate flag set to false
			const validInput = computed((): boolean => {
				if (!VALIDATE.value) return true;
				if (formElement && !ALERT.value.error && !ALERT.value.warning) {
					const inputs = [
						...Array.from(formElement.getElementsByTagName("select")),
						...Array.from(formElement.getElementsByTagName("input"))
					];

					for (let index = 0; index < inputs.length; index += 1) {
						if (inputs[index].required && !inputs[index].value) {
							return false;
						}
						// skipPAsswordMatch value check
						if (inputs[index].type === "password") {
							index += 1;
						}
					}
					return true;
				}
				return false;
			});

			return {
				validInput
			};
		}
	});
